import { FunctionComponent } from 'react';
import { Link } from 'react-router';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';

const Assets: FunctionComponent = () => {
    const { currentPropertyAssociation } = usePropertyAssociationContext();

    return (
        <div className="app__inner app__inner--center">
            <div className="text-center">
                <h1 className="large-heading">Välkommen!</h1>
                <p className="preamble">I Mitt Boende Portal kan du på snabbt och enkelt hantera och lägga till nya bokningsbara resurser för {currentPropertyAssociation?.name}.</p>

                <Link to="create" className="btn btn-lg btn-primary">
                    Lägg till resurs
                </Link>
            </div>
        </div>
    );
};

export default Assets;
